var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.842 6.13523C20.0434 6.3241 20.0536 6.64052 19.8648 6.84197L9.55227 17.842C9.45775 17.9428 9.32571 18 9.1875 18C9.0493 18 8.91726 17.9428 8.82273 17.842L4.13523 12.842C3.94637 12.6405 3.95657 12.3241 4.15803 12.1352C4.35949 11.9464 4.67591 11.9566 4.86477 12.158L9.1875 16.7689L19.1352 6.15803C19.3241 5.95657 19.6405 5.94637 19.842 6.13523Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueChecked);
export default __webpack_public_path__ + "static/media/blueChecked.baa0f86f247336cd9a9830c764a5896f.svg";
export { ForwardRef as ReactComponent };